import * as React from 'react'
import {
  FaIcon,
  faChevronRight,
  faChevronLeft,
  faChevronsLeftSolid,
  faChevronsRightSolid,
} from '@/lib/fa'


const DetailsNavigation = ({
  currentDate,
  goToDate,
}: {
  currentDate: string
  goToDate: (days: number) => void
}) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-bg-white tw-px-5 tw-py-3">
      <div className="tw-flex tw-items-center tw-gap-1">
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate(-2)}
        >
          <FaIcon icon={faChevronsLeftSolid} className="tw-h-[10px]" />
        </div>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate(-1)}
        >
          <FaIcon icon={faChevronLeft} className="tw-h-[10px]" />
        </div>
        <p className="tw-px-2 tw-text-base tw-font-semibold tw-text-content-base">
          {currentDate}
        </p>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate(1)}
        >
          <FaIcon icon={faChevronRight} className="tw-h-[10px]" />
        </div>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate(2)}
        >
          <FaIcon icon={faChevronsRightSolid} className="tw-h-[10px]" />
        </div>
      </div>
    </div>
  )
}

export default DetailsNavigation
